module.exports = __webpack_public_path__ + "img/search.32412a43.svg";